import { Controller } from "@hotwired/stimulus";

// Persists the "PI preview" toggle state on the side of the search page.
// PATCHes ProvidersController#toggle_partner_overrides so the backend mirrors
// the choice into session + the current chat's preferences. No UI feedback on
// success — the on/off state of the checkbox is the only indicator.
export default class extends Controller {
  static targets = ["input"];
  static values = { url: String };

  async flip(event) {
    const enabled = event.target.checked;
    const formData = new FormData();
    formData.append("enabled", enabled ? "true" : "false");

    const csrfMeta = document.querySelector('meta[name="csrf-token"]');
    const headers = csrfMeta ? { "X-CSRF-Token": csrfMeta.content } : {};

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers,
        body: formData,
        credentials: "same-origin",
      });
      if (!response.ok) {
        // Roll back the checkbox; the server rejected the change.
        this.inputTarget.checked = !enabled;
      }
    } catch (err) {
      this.inputTarget.checked = !enabled;
    }
  }
}
